import { TypeFormats } from '@driftt/dds.reports'

type FooterInfo = {
  impressions: number
  totalImpressions: number
  label: string
  showFooterInfo: boolean
}

export const getFooterInfo = ({
  impressions,
  totalImpressions,
  label,
  showFooterInfo,
}: FooterInfo): string => {
  if (!showFooterInfo) {
    return ''
  }

  // if totalImpressions is 0, the click rate should be 0
  if (totalImpressions === 0) {
    return `0% of 0 ${label}`
  }

  const clickRate = (impressions / totalImpressions) * 100
  return `${TypeFormats.FIXED(clickRate)}% of ${TypeFormats.RAW_HUMANIZED(
    totalImpressions
  )} ${label}`
}
